// Auto-generated normalizer for table: ContenidoTipo
export function contenidoTipoNormalize(row) {
  return {
    idContenidoTipo: row.idContenidoTipo ?? row.IdContenidoTipo ?? row['IdContenidoTipo'] ?? 0,
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    tipo: row.tipo ?? row.Tipo ?? row['Tipo'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
